var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tip",rawName:"v-tip",value:(_vm.tipText),expression:"tipText"}],staticClass:"src-chip",class:_vm.source},[_vm._v(_vm._s(_vm.$t('prm_summary_src_' + _vm.source)))])
}
var staticRenderFns = []

export { render, staticRenderFns }